import { gql } from "@apollo/client";

export const GET_ROLE_LIST = gql`
  query {
    authoring_roleList(pagination: { rows: 10, start: 0 }) {
      _id
      name
      description
      userCount
    }
  }
`;
export const SITE_MODULE_PERMISSION_LIST = gql`
  query {
    authoring_siteModulePermissionList(search: "")
  }
`;
export const ROLE_PERMISSION_LIST = gql`
  query {
    authoring_rolePermissionList(pagination: { rows: 10, start: 0 })
  }
`;
export const CREATE_ROLE = gql`
  mutation authoring_createRole($input: authoring_RoleInput) {
    authoring_createRole(input: $input) {
      message
      id
    }
  }
`;
export const DELETE_ROLE = gql`
  mutation authoring_deleteRole($input: authoring_deleteRoleInput) {
    authoring_deleteRole(input: $input) {
      message
    }
  }
`;
export const UPDATE_ROLE = gql`
  mutation authoring_updateRole($input: authoring_UpdateRoleInput) {
    authoring_updateRole(input: $input) {
      message
    }
  }
`;
export const IMPACTED_USER_COUNT = gql`
  query ($role_id: String!) {
    authoring_roleUserList(role_id: $role_id)
  }
`;
